import type { ReactNode } from "react"

export interface ScheduledSendButtonProps {
  onSend: () => void | Promise<void>
  onSchedule: (scheduledFor: string) => void | Promise<void>
  sendLabel?: ReactNode
  sendingLabel?: ReactNode
  sendIcon?: ReactNode
  disabled?: boolean
  sending?: boolean
  scheduling?: boolean
  className?: string
  recipientTimezone?: string | null
}

export interface ScheduleModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: (scheduledFor: string) => void
  disabled?: boolean
  recipientTimezone?: string | null
}

export const SCHEDULE_START_HOUR = 9
export const SCHEDULE_END_HOUR = 16
export const MAX_SCHEDULE_WEEKS = 1
